import { useState, useEffect } from 'react';

const TEXT = 'text';
const PASSWORD = 'password';

const useShowPassword = ({ currentInput, type }) => {
  const [currentType, setCurrentType] = useState(PASSWORD);
  const [inputSelection, setInputSelection] = useState([]);

  const isPassword = type === PASSWORD;
  const isCurrentOpen = currentType === TEXT;

  useEffect(() => {
    if (inputSelection.length > 0) {
      const [start, end] = inputSelection;
      currentInput.focus();
      currentInput.setSelectionRange(start, end);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentType]);

  const onBlurInput = e => {
    setInputSelection([
      e.currentTarget.selectionStart,
      e.currentTarget.selectionEnd,
    ]);
  };

  const toggleShowPassword = () =>
    setCurrentType(currentType === PASSWORD ? TEXT : PASSWORD);

  return {
    isPassword,
    isCurrentOpen,
    currentType,
    onBlurInput,
    toggleShowPassword,
  };
};

export default useShowPassword;



// WEBPACK FOOTER //
// ./app/components/fields/LineInput/useShowPassword.jsx